const formatGatheringMetadataTitle = (name: string | null | undefined) => name || "swsh";

export default formatGatheringMetadataTitle;
